import { ApolloError } from "@apollo/client";
import makeStyles from "@mui/styles/makeStyles";
import { ErrorBox } from "components/error";
import { RenderableColumnDefinition } from "components/grid/gridTypings";
import Header from "components/tableSetExplorer/Header";
import TableSetGrid from "components/tableSetExplorer/TableSetGrid";
import { IColumnProps } from "devextreme-react/data-grid";
import { DeepOmit } from "utils/typescript";
import { QueryCalculationResultInputData_cloudPlatform_useCases_calculation_inputData_tableSet_tables } from "./hooks/schema/QueryCalculationResultInputData";
import { QueryCalculationResultOutputData_cloudPlatform_useCases_calculation_resultData_tableSet_tables } from "./hooks/schema/QueryCalculationResultOutputData";

const useStyles = makeStyles(theme => ({
  flexContainer: { display: "flex", flexDirection: "column", height: "100%" },
  tableView: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    overflow: "auto"
  }
}));

type InputDataTablesProps = DeepOmit<
  QueryCalculationResultInputData_cloudPlatform_useCases_calculation_inputData_tableSet_tables,
  "__typename"
>;
type ResultDataTablesProps = DeepOmit<
  QueryCalculationResultOutputData_cloudPlatform_useCases_calculation_resultData_tableSet_tables,
  "__typename"
>;

interface CalculationResultTableProps {
  useCaseKey: string;
  useCaseVersion: string;
  calculationId: string;
  name: string;
  columnDefs?: (
    schemaName: string
  ) => RenderableColumnDefinition<IColumnProps, {}>[];
  loadData: (
    useCaseKey: string,
    useCaseVersion: string,
    calculationId: string,
    name: string,
    skip: number,
    take: number
  ) => Promise<InputDataTablesProps | ResultDataTablesProps | null | undefined>;
  error?: ApolloError;
  loading: boolean;
  backgroundColor: string;
}
export const CalculationResultTable = ({
  useCaseKey,
  useCaseVersion,
  calculationId,
  name,
  columnDefs,
  loadData,
  error,

  backgroundColor
}: CalculationResultTableProps) => {
  const { flexContainer, tableView } = useStyles();

  if (error) return <ErrorBox apolloError={error} />;

  return (
    <div className={flexContainer}>
      <div key={name} className={tableView}>
        {/* @ts-ignore */}
        <Header name={name} backgroundColor={backgroundColor} />
        <TableSetGrid
          key={name}
          columnDefs={columnDefs}
          name={name}
          useCaseKey={useCaseKey}
          /* @ts-ignore */
          useCaseVersion={useCaseVersion}
          calculationId={calculationId}
          loadData={loadData}
        />
      </div>
    </div>
  );
};

export default CalculationResultTable;
